import { render, staticRenderFns } from "./saletotal.vue?vue&type=template&id=0974054c&scoped=true"
import script from "./saletotal.vue?vue&type=script&lang=js"
export * from "./saletotal.vue?vue&type=script&lang=js"
import style0 from "./saletotal.vue?vue&type=style&index=0&id=0974054c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0974054c",
  null
  
)

export default component.exports